var _pattern, _pattern2, _pattern3, _pattern4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetItOnGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 135.7 40",
    viewBox: "0 0 135.7 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "d",
    y: 40,
    width: 124,
    height: 48,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -48 124 48"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -48,
    width: 124,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ad",
    y: -48,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ad"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.6-20.7-11.6 6.6c-0.6 0.4-1.2 0.3-1.6 0l-0.1 0.1 0.1 0.1c0.4 0.3 1 0.4 1.6 0l11.6-6.8c0.1 0.1 0 0 0 0z"
  })))), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    id: "c",
    y: 40,
    width: 124,
    height: 48,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -48 124 48"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -48,
    width: 124,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "w",
    y: -48,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.3-14.1c-0.2-0.2-0.4-0.6-0.4-1.1v0.1c0 0.5 0.1 0.9 0.4 1.1v-0.1z"
  })))), _pattern3 || (_pattern3 = /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    y: 40,
    width: 124,
    height: 48,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -48 124 48"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -48,
    width: 124,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "u",
    y: -48,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.6-23-4 2.3 0.1 0.1 3.9-2.2c0.6-0.3 0.8-0.7 0.8-1.2 0 0.4-0.3 0.7-0.8 1z"
  })))), _pattern4 || (_pattern4 = /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    y: 40,
    width: 124,
    height: 48,
    overflow: "visible",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 -48 124 48"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -48,
    width: 124,
    height: 48,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "s",
    y: -48,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18-33.9 15.6 8.9c0.5 0.3 0.8 0.7 0.8 1 0-0.4-0.3-0.8-0.8-1.2l-15.6-8.8c-1.1-0.6-2-0.1-2 1.2v0.1c0-1.3 0.9-1.8 2-1.2z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -9.4248 49.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0024 0 0 .99073 -.29665 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 8h-100c-2.2 0-4 1.8-4 4v24c0 2.2 1.8 4 4 4h100c2.2 0 4-1.8 4-4v-24c0-2.2-1.8-4-4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112 39.4c1.9 0 3.4-1.5 3.4-3.4v-24c0-1.9-1.5-3.4-3.4-3.4h-100c-1.9 0-3.4 1.5-3.4 3.4v24c0 1.9 1.5 3.4 3.4 3.4h100m0 0.6h-100c-2.2 0-4-1.8-4-4v-24c0-2.2 1.8-4 4-4h100c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.4 28.5h-0.6v1.6h0.5c0.4 0.4 0.6 1 0.6 1.9v2.4h3.2v-4.2h0.5v-1.6h-0.6v1h-3.6v-1.1zm1.1 3.5c0-0.8-0.1-1.4-0.5-1.9h2.4v3.7h-2v-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.5 30.2c-0.5-0.5-1.1-0.7-1.8-0.7s-1.3 0.2-1.8 0.7-0.7 1.1-0.7 1.8 0.2 1.3 0.7 1.8 1.1 0.7 1.8 0.7 1.3-0.2 1.8-0.7 0.7-1.1 0.7-1.8-0.3-1.3-0.7-1.8zm-3.1 0.4c0.4-0.4 0.8-0.5 1.3-0.5s0.9 0.2 1.3 0.5c0.4 0.4 0.5 0.8 0.5 1.4s-0.2 1-0.5 1.4c-0.4 0.4-0.8 0.5-1.3 0.5s-0.9-0.2-1.3-0.5c-0.4-0.4-0.5-0.9-0.5-1.4s0.1-1 0.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.3 29.4c-0.7 0-1.3 0.2-1.8 0.7s-0.7 1.1-0.7 1.8 0.2 1.3 0.7 1.8 1.1 0.7 1.8 0.7 1.3-0.3 1.8-0.8l-0.4-0.4c-0.3 0.4-0.8 0.6-1.3 0.6s-1-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.4s0.2-1 0.5-1.4 0.8-0.5 1.3-0.5c0.6 0 1.1 0.2 1.5 0.7l0.4-0.4c-0.2-0.3-0.5-0.5-0.8-0.6-0.5-0.2-0.9-0.3-1.2-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.7 29.6h-0.7v4.2h-1.3v0.6h3.3v-0.6h-1.3v-4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.2 34.4-1.8-4.1c-0.2-0.6-0.6-0.9-1.1-0.9-0.1 0-0.3 0-0.5 0.1l0.2 0.6c0.1-0.1 0.2-0.1 0.3-0.1s0.3 0 0.3 0.1c0.1 0.1 0.2 0.2 0.2 0.3l0.2 0.4-1.6 3.6h0.7l1.2-2.8 1.2 2.8h0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.9 29.6v4.8h3.5v-4.8h-0.6v4.2h-2.2v-4.2h-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.5 29.6v4.8h0.6v-2.1h2.4v2.1h0.6v-4.8h-0.6v2.2h-2.4v-2.2h-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.1 30.2c-0.5-0.5-1.1-0.7-1.8-0.7s-1.3 0.2-1.8 0.7-0.7 1.1-0.7 1.8 0.2 1.3 0.7 1.8 1.1 0.7 1.8 0.7 1.3-0.2 1.8-0.7 0.7-1.1 0.7-1.8-0.2-1.3-0.7-1.8zm-3 0.4c0.4-0.4 0.8-0.5 1.3-0.5s0.9 0.2 1.3 0.5c0.4 0.4 0.5 0.8 0.5 1.4s-0.2 1-0.5 1.4c-0.4 0.4-0.8 0.5-1.3 0.5s-0.9-0.2-1.3-0.5c-0.4-0.4-0.5-0.8-0.5-1.4s0.1-1 0.5-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.3 29.6v4.8h1.7c0.4 0 0.7-0.1 1-0.4s0.4-0.6 0.4-0.9c0-0.2-0.1-0.4-0.2-0.6s-0.3-0.3-0.5-0.4c0.2-0.1 0.4-0.2 0.6-0.4s0.2-0.4 0.2-0.7c0-0.4-0.1-0.7-0.4-1s-0.6-0.4-1-0.4h-1.8zm0.6 2.7h1.1c0.2 0 0.4 0.1 0.6 0.2 0.1 0.2 0.2 0.3 0.2 0.5s-0.1 0.4-0.2 0.5c-0.1 0.2-0.3 0.2-0.5 0.2h-1.1v-1.4zm0-2.1h1.2c0.2 0 0.4 0.1 0.6 0.3 0.1 0.2 0.2 0.3 0.2 0.5s-0.1 0.4-0.2 0.5c-0.2 0.2-0.4 0.3-0.6 0.3h-1.2v-1.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m62.5 22.6c-1.9 0-3.4-1.4-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.4 3.4 3.4-1.5 3.4-3.4 3.4zm0-5.5c-1 0-1.9 0.9-1.9 2.1s0.9 2.1 1.9 2.1 1.9-0.8 1.9-2.1c0-1.2-0.9-2.1-1.9-2.1zm-7.4 5.5c-1.9 0-3.4-1.4-3.4-3.4s1.5-3.4 3.4-3.4 3.4 1.4 3.4 3.4-1.6 3.4-3.4 3.4zm0-5.5c-1 0-1.9 0.9-1.9 2.1s0.9 2.1 1.9 2.1 1.9-0.8 1.9-2.1c0-1.2-0.9-2.1-1.9-2.1zm-8.9 4.5v-1.4h3.5c-0.1-0.8-0.4-1.4-0.8-1.8-0.5-0.5-1.3-1.1-2.7-1.1-2.1 0-3.8 1.7-3.8 3.8s1.7 3.8 3.8 3.8c1.1 0 2-0.4 2.6-1l1 1c-0.9 0.8-2 1.5-3.6 1.5-2.9 0-5.4-2.4-5.4-5.3s2.4-5.3 5.4-5.3c1.6 0 2.8 0.5 3.7 1.5 1 1 1.3 2.3 1.3 3.4 0 0.3 0 0.6-0.1 0.9h-4.9zm36.2-1.2c-0.3 0.8-1.1 2.2-2.9 2.2s-3.2-1.4-3.2-3.4c0-1.9 1.4-3.4 3.4-3.4 1.6 0 2.5 1 2.8 1.5l-1.2 0.8c-0.4-0.6-0.9-0.9-1.7-0.9s-1.3 0.3-1.6 1l4.6 1.9c0-0.1-0.2 0.3-0.2 0.3zm-4.6-1.1c0 1.3 1 2 1.8 2 0.6 0 1.1-0.3 1.3-0.7-0.1 0-3.1-1.3-3.1-1.3zm-3.7-3.3h1.5v10h-1.5v-10zm-2.4 5.8c-0.4 0.4-1 0.8-1.8 0.8-1.7 0-3.3-1.5-3.3-3.4s1.6-3.4 3.3-3.4c0.8 0 1.5 0.4 1.8 0.8h0.1v-0.5c0-1.3-0.7-2-1.8-2-0.9 0-1.5 0.7-1.7 1.2l-1.3-0.5c0.4-0.9 1.4-2 3-2 1.8 0 3.2 1 3.2 3.5v6.1h-1.4v-0.6zm-1.8-4.7c-1 0-1.9 0.9-1.9 2.1s0.9 2.1 1.9 2.1 1.8-0.9 1.8-2.1c0.1-1.2-0.7-2.1-1.8-2.1zm19.5 8.9h-3.6v-10h1.5v3.8h2.1c1.7 0 3.3 1.2 3.3 3.1s-1.6 3.1-3.3 3.1zm0.1-4.8h-2.1v3.4h2.1c1.1 0 1.8-0.9 1.8-1.7-0.1-0.8-0.7-1.7-1.8-1.7zm9.2 1.4c-1.1 0-2.2-0.5-2.7-1.5l1.3-0.6c0.3 0.6 0.8 0.7 1.4 0.7 0.8 0 1.6-0.5 1.6-1.3v-0.1c-0.3 0.2-0.8 0.4-1.6 0.4-1.4 0-2.9-0.8-2.9-2.2 0-1.3 1.2-2.2 2.5-2.2 1 0 1.6 0.5 1.9 1h0.1v-0.8h1.4v3.8c0 1.8-1.3 2.8-3 2.8zm-0.2-5.5c-0.5 0-1.2 0.2-1.2 0.8 0 0.8 0.8 1.1 1.6 1.1 0.7 0 1-0.1 1.4-0.3-0.1-0.9-0.9-1.6-1.8-1.6zm8.5 5.3-1.7-4.3h-0.1l-1.8 4.3h-1.6l2.7-6.1-1.5-3.3h1.6l4.1 9.4h-1.7zm-13.5-6.4h1.5v10h-1.5v-10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 32.745,
    x2: 15.962,
    y1: 157.18,
    y2: 140.39,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -7.384 170.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: 0.0066
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: 0.2601
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: 0.5122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: 0.7604
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m16.3 34c-0.2-0.2-0.4-0.6-0.4-1.1v-17.7c0-0.5 0.1-0.9 0.4-1.1l0.1-0.1 9.9 9.9v0.2l-10 9.9z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 42.35,
    x2: 18.153,
    y1: 148.06,
    y2: 148.06,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -7.384 170.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: 0.4087
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: 0.7754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.6 20.6-3.3 3.3v0.2l3.3 3.3h0.1l3.9-2.2c1.1-0.6 1.1-1.7 0-2.3l-4-2.3c0.1 0 0 0 0 0z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 28.502,
    x2: 5.7435,
    y1: 152.94,
    y2: 130.19,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -7.384 170.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.7 20.6-3.4 3.4-10-10c0.4-0.4 1-0.4 1.7 0l11.7 6.6",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 14.513,
    x2: 24.676,
    y1: 157.33,
    y2: 147.17,
    gradientTransform: "matrix(1.0024 0 0 -.9907 -7.384 170.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: 0.0685
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: 0.4762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: 0.8009
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.7 27.4-11.7 6.6c-0.7 0.4-1.3 0.3-1.7-0.1l10-10 3.4 3.5z",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ar",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ar)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "q",
    x: -4.7,
    y: -3.1,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 40.3h99v-38.8h-99v38.8z",
    clipPath: "url(#an)",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#p)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "am",
    x: -15.7,
    y: -5.7,
    width: 155.4,
    height: 59.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#am"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "k",
    xlinkHref: "#d",
    patternTransform: "matrix(1.253 0 0 -1.2384 2126.9 -17667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0h124v48H0V0z",
    fill: "url(#k)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "aq",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#aq)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ak",
    x: -4.7,
    y: -3.1,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ak"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 40.3h99v-38.8h-99v38.8z",
    clipPath: "url(#aj)",
    fillOpacity: 0.12
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#o)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ai",
    x: -15.7,
    y: -5.7,
    width: 155.4,
    height: 59.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ai"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ah)"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "j",
    xlinkHref: "#c",
    patternTransform: "matrix(1.253 0 0 -1.2384 2126.9 -17667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0h124v48H0V0z",
    fill: "url(#j)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ap",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    x: 0,
    y: -48,
    width: 124,
    height: 48,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ap)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ag",
    x: -4.7,
    y: -3.1,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ag"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 40.3h99v-38.8h-99v38.8z",
    clipPath: "url(#af)",
    fillOpacity: 0.12
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ae",
    x: -15.7,
    y: -5.7,
    width: 155.4,
    height: 59.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ae"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "i",
    xlinkHref: "#b",
    patternTransform: "matrix(1.253 0 0 -1.2384 2126.9 -17667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0h124v48H0V0z",
    fill: "url(#i)"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ao",
    x: 0,
    y: -48,
    width: 124,
    height: 48.2,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    x: 0,
    y: -48,
    width: 124,
    height: 48.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#ao)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ab",
    x: -4.7,
    y: -3.1,
    width: 124,
    height: 48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#ab"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 40.3h99v-38.8h-99v38.8z",
    clipPath: "url(#aa)",
    fillOpacity: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "z",
    x: -15.7,
    y: -5.7,
    width: 155.4,
    height: 59.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#y)"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "h",
    xlinkHref: "#a",
    patternTransform: "matrix(1.253 0 0 -1.2384 2126.9 -17667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-0.2h124v48H0V-0.2z",
    fill: "url(#h)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetItOnGooglePlay);
export default __webpack_public_path__ + "static/media/Get_it_on_Google_play.674ebeb54ecbc0c4e5ca0ec9be53d9b7.svg";
export { ForwardRef as ReactComponent };